// cm-coding: Impersonation is an administrator debugging view scoped to one
// browser tab. Session storage survives the required page reload while keeping
// other tabs, devices, and Playwright contexts authenticated as their own
// effective users; the backend still authorizes the real CAS user per request.

export const IMPERSONATION_HEADER = 'X-DocReview-Impersonate-User';

const IMPERSONATION_STORAGE_KEY = 'docreview_impersonation_target';

export function getImpersonationTarget(): string | null {
  return sessionStorage.getItem(IMPERSONATION_STORAGE_KEY);
}

export function setImpersonationTarget(userId: string | null): void {
  if (userId) {
    sessionStorage.setItem(IMPERSONATION_STORAGE_KEY, userId);
    return;
  }
  sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY);
}
